import "slick-carousel/slick/slick";

var hero_slider_v2_top = jQuery("#hero_slider_v2_top")
var hero_slider_v2_bottom = jQuery("#hero_slider_v2_bottom")


jQuery(document).ready(function () {
    if (hero_slider_v2_top.length && hero_slider_v2_bottom.length) {

        hero_slider_v2_top.slick({
            asNavFor: hero_slider_v2_bottom,
            arrows: false,
            dots: false,
            fade: true,

        });

        hero_slider_v2_bottom.slick({
            asNavFor: hero_slider_v2_top,
            arrows: false,
            dots: false,
            fade: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            focusOnSelect: true,
            responsive: [

                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]

        });
    }
});

// Button navigation
jQuery('.hero-slider-top-button-prev').click(function (e) {
    e.preventDefault();
    hero_slider_v2_top.slick('slickPrev');
});

jQuery('.hero-slider-top-button-next').click(function (e) {
    e.preventDefault();
    hero_slider_v2_top.slick('slickNext');
});

